import { Link } from "react-router-dom";
import DeathgardenImg from "../../../../img/Deathgarden.jpg";

const DeathgardenTab = () => {
  return (
    <>
      <section className="ServerBox ms-lg-5 col-lg-3">
        <img
          src={DeathgardenImg}
          alt="Deathgarden icon"
          className="ServerBoxImg mb-4 mt-lg-2"
        />
        <h2>Deathgarden Bloodharvest</h2>
        <div className="d-flex flex-column">
          <Link
            to="/files/[Game].txt"
            target="_blank"
            className="mb-3 d-flex flex-column"
            download={true}
          >
            <button>Download</button>
          </Link>
          <Link to="/servers/deathgarden" className="mb-3 d-flex flex-column">
            <button>More Info</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default DeathgardenTab;
